import { memo } from "react";

import { IconSeekBack, IconSeekForward } from "@/components/icons/player.icons";

const SeekButton = memo(({ seek, direction }: { seek: (time: number) => void; direction: "back" | "forward" }) => {
  const seekTime = direction === "back" ? -10 : 10;

  return (
    <div onClick={() => seek(seekTime)}>
      {direction === "back" ? (
        <IconSeekBack className="player-icon !fill-transparent stroke-white" />
      ) : (
        <IconSeekForward className="player-icon !fill-transparent stroke-white" />
      )}
    </div>
  );
});
SeekButton.displayName = "SeekButton";

export default SeekButton;
